import React, {useCallback, useEffect, useRef, useState} from "react";
import {Store} from "../models/Store";
import * as firebase from 'firebase/app';
import {GroupPath} from "../models/GroupPath";
import {ReadonlyCanvas2} from "./ReadonlyCanvas2";
import {t4} from "./DrawingDataType";
import './AdminUndoneListPage.scss';
import {Link} from "react-router-dom";

export const AdminUndoneListPage = () => {

    const [list, setList] = useState<any[]>([]);
    const ref = useRef<HTMLInputElement | null>(null);
    const [groupId, setGroupId] = useState('dev');

    useEffect(() => {
        onSearchClick();
    }, []);

    const onSearchClick = useCallback(() => {
        (async () => {
            const fs = Store.getFirestoreInstance();
            const path = new GroupPath(groupId).value;
            const q = fs.collection(path)
                .where('isDone', '==', false);

            const snapshot = await q.get();
            const arr: firebase.firestore.DocumentData[] = [];

            snapshot.docs.forEach(value => {
                const data = value.data() as t4;
                const data2 = {id: value.id, data: data};

                // test
                // 全部falseにする
                // fs.doc(path+value.id).update('isDone',false);

                arr.push(data2);
            });
            setList(arr);
        })();
    }, [groupId]);

    const onDoneButtonClick = useCallback((e) => {
        (async () => {
            const dataId = e.currentTarget.id;
            const fs = Store.getFirestoreInstance();

            const path = new GroupPath(groupId).value + dataId;

            const documentReference = fs.doc(path);

            await documentReference.update(
                'isDone', true
            );

            onSearchClick();
        })();
    }, []);

    return (<div className='undone-list'>
        <h6>ひかりの実スマイルアトリエ > 管理画面</h6>
        <h1>未完了の笑顔を検索・更新する</h1>

        <Link to={'/admin'}>&lt;&nbsp;戻る</Link>

        <hr/>

        <h2>検索</h2>
        <div className='undone-list__search'><label htmlFor="">グループID</label><input ref={ref} type="text"
                                                                                    value={groupId}
                                                                                    onChange={e => setGroupId(e.currentTarget.value)}/>
            <button onClick={onSearchClick}>検索</button>
        </div>

        <h2>検索結果・完了処理</h2>
        <div className='undone-list__result'>
            {
                list.map(item => (
                    <div key={item.id} className='undone-list__result-item'>
                        <ReadonlyCanvas2 data={item.data} size={100}/>
                        <button onClick={onDoneButtonClick} id={item.id}>完了にする</button>
                    </div>
                ))
            }
        </div>
    </div>);
};